/* eslint-disable import/no-unresolved */
import { Tabs } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { FC, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../PageHeader';
import { useWorkspaceStore } from '../../../store/workspace.store';

const SettingsHeader: FC<{ children: ReactNode }> = ({ children }) => {
    const { t: tp } = useTranslation('shared', { keyPrefix: 'PAGES' });

    const workspace = useWorkspaceStore((state) => state.data);

    const navigate = useNavigate();
    const { '*': currentRoute } = useParams();

    const { t } = useTranslation('settings', { keyPrefix: 'SETTINGS.TABS' });

    const { tabs, routes } = useMemo(() => {
        const options = [
            { key: 0, label: t('GENERAL'), route: 'general' },
            { key: 1, label: t('COVERAGE'), route: 'coverage' },
        ];

        const routes = options.map((option) => option.route);

        return {
            tabs: options,
            routes,
        };
    }, []);

    const activeTab = routes.findIndex((route) => route === currentRoute);

    const handleChangeTab = (index: string) => {
        navigate(`/settings/${routes[parseInt(index, 10)]}`);
    };

    const items = tabs.map((tab, index) => ({
        key: index.toString(),
        label: tab.label,
    }));

    return (
        <div className="screen">
            <PageHeader
                title={`${tp('SETTINGS')} | ${workspace?.name}`}
                style={{ padding: 0 }}
                footer={(
                    <Tabs
                        activeKey={activeTab.toString()}
                        onChange={handleChangeTab}
                        items={items}
                    />
                )}
            />
            <div className="section">
                {children}
            </div>
        </div>
    );
};

export { SettingsHeader };
